<template v-slot>
  <vxe-form
      ref="xForm"
      class="my-form2"
      title-align="right"
      title-width="100"
      :data="formInfo"
      :rules="formRules"
      @submit="submitEvent"
      @reset="close"
  >
    <vxe-form-item title="排序值" field="orderBy" span="12" style="height: 75px;display: flex;align-items: center;">
      <template v-slot="scope">
        <vxe-input
            v-model="formInfo.orderBy"
            type="number"
            placeholder="输入序号 数字小的排前"
            clearable
            style="width: 220px;"
            @input="$refs.xForm.updateStatus(scope)"
        ></vxe-input>
      </template>
    </vxe-form-item>
    <vxe-form-item title="字典内容类型" field="contractBusType" span="24">
      <template v-slot>
        <vxe-select v-model="formInfo.valueType" :options="valueType" style="width: 200px" @change="change"
                    placeholder="全部"></vxe-select>
      </template>
    </vxe-form-item>
    <vxe-form-item title="字典内容" field="dictText" span="24" v-if="formInfo.valueType === 1" style="max-height: 300px;">
      <template v-slot="scope">
        <vxe-textarea
            v-model="formInfo.dictText"
            placeholder="请输入字典内容"
            clearable
            :autosize="{minRows:7}"
            @input="$refs.xForm.updateStatus(scope)"
        ></vxe-textarea>
      </template>
    </vxe-form-item>
    <vxe-form-item title="字典内容" field="dictText" span="24" v-if="formInfo.valueType === 2" style="height: 300px;">
      <template>
        <quill-editor
            style="height: 200px;"
            v-model="formInfo.dictText"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
            @change="onEditorChange($event)">
        </quill-editor>
      </template>
    </vxe-form-item>
    <vxe-form-item title="字典描述" field="note" span="24">
      <template v-slot="scope">
        <vxe-textarea
            v-model="formInfo.note"
            @input="$refs.xForm.updateStatus(scope)"
        ></vxe-textarea>
      </template>
    </vxe-form-item>
    <vxe-form-item align="center" span="24">
      <template v-slot>
        <vxe-button type="submit" status="primary">确 定</vxe-button>
        <vxe-button type="reset" @click="close">取 消</vxe-button>
      </template>
    </vxe-form-item>
  </vxe-form>
</template>

<script>
  import auth from "@/utils/auth";
  import $api from "@/apiProvider";
  import UploadOneImg from "@/components/common/UploadOneImg";
  import {showLoading, hideLoading} from '@/utils/util';
  import {quillEditor} from "vue-quill-editor"; //调用编辑器
  import {quillRedefine} from 'vue-quill-editor-upload'
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';

  const assign = (val) => Object.assign({}, val);
  export default {
    components: {quillEditor
    },
    props: {
      isSystem: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        formInfo: {
          id: '',
          valueType: 1,
        },
        formRules: {
          dictText: [
            {required: true, message: "请输入字典内容"},
          ],
          dictCode: [
            {required: true, message: "请输入编号"},
          ],
          valueType: [
            {required: true, message: "请选择"},
          ]
        },
        valueType: [
          {
            label: '文本',
            value: 1
          },
          {
            label: '富文本',
            value: 2
          }
        ],
        editorOption: {},
      };
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
      },
    },
    created() {
      this.editorOption = quillRedefine(
        {
          // 图片上传的设置
          uploadConfig: {
            action: process.env.VUE_APP_API + "/api/tool/oss/upload",  // 必填参数 图片上传地址
            // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
            // 你必须把返回的数据中所包含的图片地址 return 回去
            res: (res) => {
              return res.data.url
            },
            methods: 'POST',  // 可选参数 图片上传方式  默认为post
            token: auth.getAuth().token,  // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
            name: 'file',  // 可选参数 文件的参数名 默认为img
            size: 500,  // 可选参数   图片限制大小，单位为Kb, 1M = 1024Kb
            accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',  // 可选参数 可上传的图片格式
            start: () => {
            },  // 可选参数 接收一个函数 开始上传数据时会触发
            end: () => {
            },  // 可选参数 接收一个函数 上传数据完成（成功或者失败）时会触发
            success: () => {
            },  // 可选参数 接收一个函数 上传数据成功时会触发
            error: () => {
            }  // 可选参数 接收一个函数 上传数据中断时会触发
          },
          // 以下所有设置都和vue-quill-editor本身所对应
          placeholder: '请输入字典内容',  // 可选参数 富文本框内的提示语
        }
      )
    },
    mounted() {

    },
    methods: {
      change() {
        this.formInfo.dictText = '';
      },
      //把实体格式字符串转义成HTML格式的字符串
      escapeStringHTML(str) {
        str = str.replace(/&lt;/g, '<');
        str = str.replace(/&gt;/g, '>');
        return str;
      },
      onEditorBlur() {
      }
      , // 失去焦点事件
      onEditorFocus() {
      }
      , // 获得焦点事件
      onEditorChange() {
      }
      , // 内容改变事件
      setDictCodeP(dictCodeP) {
        this.formInfo.dictCodeP = dictCodeP;
      },
      setUpdate(row) {
        this.formInfo = Object.assign({}, row);
      },
      changeFile(imgUrl) {
        this.formInfo.iconUrl = imgUrl;
      },
      async submitEvent() {
        showLoading();
        let res = await $api.dict.post('addOrUpdateDic', this.formInfo);
        hideLoading();
        if (res.status === 1) {
          this.$Message.success('提交成功');
          this.reset();
          this.$emit('afterSave');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      reset() {
        this.formInfo = {
          id: ''
        }
        this.$refs.xForm.clearValidate();
      },
      close() {
        this.$emit('close');
      }
    },
  }
  ;
</script>
<style>

</style>
